<template>
  <div id="app">
    <Header />
    <router-view class="main" />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/navigation/header.vue'
import Footer from '@/components/navigation/footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="scss">
html {
  height: 100%;
}

body {
  min-height: 100%;
  margin: 0;
  background-color: #000;
}

#app {
  font-family: "Courier New", Courier, monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}

a {
  color: #fff;
}

.main {
  padding: 150px 10% 10px 10%;
}

hr {
  color: #42b983;
}
</style>
